import React, { useEffect,useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { StyledEngineProvider } from '@mui/material/styles';
import './App.css';

import { Dashboard, Login, Profile, Settings, HoldersStructure, About, CV, MobileDashboard, SceneBuilder, SyncLogs } from './pages';

import { Navbar, Sidebar } from './components';
import { useStateContext } from './contexts/ContextProvider';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { MyApolloClient } from './components';
import MobileBlocker from "./components/MobileBlocker"; // Import MobileBlocker



import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const cache = createCache({
  key: 'css',
  prepend: true, // Ensure Emotion's styles are injected first
});

const isTokenExpired = (token) => {
  try {
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = atob(payloadBase64);
    const payload = JSON.parse(decodedPayload);
    const exp = payload.exp;
    const now = Date.now() / 1000; // Get current date in Unix timestamp (seconds)
    return now > exp;
  } catch (error) {
    // In case of an error (e.g., token is malformed), assume the token is invalid
    console.error('Error decoding token:', error);
    return true;
  }
};

const App = () => {
  const { activeMenu } = useStateContext();
  const {isLogged, setIsLogged} = useStateContext();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

  // TOKEN check (login)
  useEffect(() => {
    const token = localStorage.getItem('jwt');
  
    if (token && !isTokenExpired(token)) {
      // If the token is present and not expired
      setIsLogged(true);
      console.log("Token is valid and did not expire."); // Corrected log statement
    } else {
      // If the token is not present or expired
      localStorage.removeItem('jwt'); // Clear the expired token
      setIsLogged(false);
      console.log("Token is either not present or expired."); // Corrected log placement and message
      if(token && isTokenExpired(token)){
        if ('caches' in window) { // Again, ensure caches are supported
          caches.keys().then(names => {
              return Promise.all(names.map(name => caches.delete(name)));
          }).then(() => {
              console.log("Caches cleared. Reloading the page to fetch latest version.");
              window.location.reload();
          });
        }
      }
      
    }
    
     // Screen size check (desktop-only)
    const handleResize = () => setIsMobile(window.innerWidth < 1280);
    setIsMobile(window.innerWidth < 1280); // Initial check
    // Function to handle storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'jwt') {
        const newToken = e.newValue;
        if (newToken && !isTokenExpired(newToken)) {
          setIsLogged(true);
        } else {
          setIsLogged(false);
        }
      }
    };
  
    // Add event listener for storage changes
    window.addEventListener('resize', handleResize);
    window.addEventListener('storage', handleStorageChange);
  
    // Cleanup on unmount
    return () => {
      window.addEventListener('resize', handleResize);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);




  return (
    <ApolloProvider client={MyApolloClient}>
    <CacheProvider value={cache}>
      <StyledEngineProvider injectFirst>
         <BrowserRouter>
            {isMobile ? (
              // MOBILE LAYOUT
              <Routes>
                <Route path="/" element={<MobileDashboard />} />
                <Route path="/Dashboard" element={<MobileDashboard />} />
                <Route path="/CV" element={<CV />} />
                <Route path="*" element={<MobileDashboard />} />
              </Routes>
            ) : (
              // DESKTOP LAYOUT
              <div className="flex relative bg-main-bg h-screen">
                {/* Sidebar */}
                <div
                  className={`fixed top-0 left-0 h-screen bg-main-bg transition-all duration-200 z-50 ${
                    activeMenu ? 'w-56' : 'w-0'
                  }`}
                >
                  <Sidebar />
                </div>

                {/* Main Content */}
                <div
                  className={`flex flex-col transition-all duration-200 bg-transparent ${
                    activeMenu ? 'md:ml-56' : 'md:ml-0'
                  } w-full h-screen`}
                >
                  {/* Navbar */}
                  <div className="sticky top-0 bg-main-dark-bg navbar z-40 w-full">
                    <Navbar />
                  </div>

                  {/* Scrollable Content Area */}
                  <div className="relative flex-1 overflow-auto">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/Dashboard" element={<Dashboard />} />
                      <Route path="/Profil" element={<Profile />} />
                      <Route path="/CV" element={<CV />} />
                      <Route path="/Login" element={<Login />} />
                      <Route path="/Structure info" element={<HoldersStructure />} />
                      <Route path="/About" element={<About />} />
                      <Route path="/SceneBuilder" element={<SceneBuilder />} />
                      <Route path="/SyncLogs" element={<SyncLogs />} />

                    </Routes>
                  </div>
                </div>
              </div>
            )}
          </BrowserRouter>
      </StyledEngineProvider>
    </CacheProvider>
    </ApolloProvider>
  );
};

export default App;
